jQuery(document).ready(function($) {
    $(".owl-carousel").owlCarousel();

    $(".jobs-list-carousel").owlCarousel({
        margin:10,
        responsiveClass:true,
        responsive:{
            0:{
                items:1,
                nav:true
            },
            600:{
                items:2,
                nav:true
            },
            1000:{
                items:4,
                nav:false
            }
        }
    });

    $(".item-image").each(function() {
        var $this = $(this);

        var w = $this.attr('data-width');
        var h = $this.attr('data-height');
        var image = $this.attr('data-image');

        $this.css('background-image', "url('"+image+"')");
        //$this.append('<div class="sizer" style="width: '+w+'px; height: '+h+'px"></div>');
    });

    $(".linkeditem").click(function() {
        var url = $(this).attr('data-url');
        window.location.href = url;
    });

    $("#toggle-nav").click(function(e) {
        var $this = $(this);
        var wrapper = $('.page-content-wrapper');
        if($this.hasClass('open')) {
            // Close nav
            $this.removeClass('open');
            wrapper.removeClass('show-nav');
            $("body").removeClass('navopen');
        } else {
            // Open nav
            $this.addClass('open');
            wrapper.addClass('show-nav');
            $("body").addClass('navopen');
        }
        e.stopImmediatePropagation();
        return false;
    });

    $(".icon-search").click(function(e) {
        $("#toggle-nav").trigger('click');
    });

    /*$(window).scroll(function() {
        var st = $(window).scrollTop;

        $(".parallax").each(function() {
            var $this = $(this);

        });
    });*/

});
/*
skrollr.init({
    forceHeight: false
});*/